module.exports = "<mat-expansion-panel class='viewer'>\r\n  \t<mat-expansion-panel-header>\r\n\t    <mat-panel-title class='header'>\r\n\t      <div class='header'>Modules</div>\r\n\t    </mat-panel-title>\r\n  \t</mat-expansion-panel-header>\r\n\t<div class='container'>\r\n\t\t<div *ngFor=\"let fn of functions\">\r\n\t\t\t<div class='function'>{{fn}}</div>\r\n\t\t</div>\r\n\t</div>\r\n</mat-expansion-panel>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Akshata/Documents/GitHub/mobius-dev/src/app/ui-components/viewers/module-viewer/module-viewer.component.html
// module id = ../../../../../src/app/ui-components/viewers/module-viewer/module-viewer.component.html
// module chunks = main